export default __webpack_public_path__ + "static/media/goo.04288c75.mp4";